var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "csp-desktop-info-card",
    {
      attrs: {
        cols: _vm.cols,
        "form-context": _vm.formContext,
        icon: "inticon-autoclaim_company_group",
        title: "Firmengruppe",
      },
      on: { "cancel-form": _vm.handleCancel, save: _vm.saveFirmGroupBasedata },
    },
    [
      _c(
        "b-row",
        [
          _c("csp-desktop-info-card-element", {
            staticClass: "col-3",
            attrs: {
              "form-context": _vm.formContext,
              label: "Name",
              property: "name",
              required: "",
              type: "text",
            },
          }),
          _vm._v(" "),
          _c("csp-desktop-info-card-element", {
            staticClass: "col-3",
            attrs: {
              "form-context": _vm.formContext,
              label: "Firmennummer",
              property: "firmNumber",
              type: "text",
            },
          }),
          _vm._v(" "),
          _c("csp-desktop-info-card-element", {
            staticClass: "col-3",
            attrs: {
              "form-context": _vm.formContext,
              label: "Firmengruppennummer",
              property: "firmGroupNumber",
              type: "text",
            },
          }),
          _vm._v(" "),
          _c("csp-desktop-info-card-element", {
            staticClass: "col-3",
            attrs: {
              "form-context": _vm.formContext,
              label: "Adressnummer",
              property: "addressNumber",
              type: "text",
            },
          }),
          _vm._v(" "),
          _c("csp-desktop-info-card-element", {
            staticClass: "col-3",
            attrs: {
              "form-context": _vm.formContext,
              label: "Versicherungsnummer",
              property: "insuranceNumber",
              type: "text",
            },
          }),
          _vm._v(" "),
          _c("csp-desktop-info-card-element", {
            staticClass: "col-3",
            attrs: {
              "form-context": _vm.formContext,
              label: "Firmenebene",
              "options-loader": _vm.loadOptions("firmLevel"),
              property: "firmLevel",
              type: "autocomplete",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c("csp-desktop-info-card-element", {
            staticClass: "col-3",
            attrs: {
              "form-context": _vm.formContext,
              label: "Rechnungsempfänger Name",
              property: "accountingName",
              type: "text",
            },
          }),
          _vm._v(" "),
          _c("csp-desktop-info-card-element", {
            staticClass: "col-3",
            attrs: {
              "form-context": _vm.formContext,
              label: "Rechnungsempfänger Straße",
              property: "accountingStreet",
              type: "text",
            },
          }),
          _vm._v(" "),
          _c("csp-desktop-info-card-element", {
            staticClass: "col-3",
            attrs: {
              "form-context": _vm.formContext,
              label: "Rechnungsempfänger PLZ",
              property: "accountingPostalCode",
              type: "text",
            },
          }),
          _vm._v(" "),
          _c("csp-desktop-info-card-element", {
            staticClass: "col-3",
            attrs: {
              "form-context": _vm.formContext,
              label: "Rechnungsempfänger Ort",
              property: "accountingPlace",
              type: "text",
            },
          }),
          _vm._v(" "),
          _c("csp-desktop-info-card-element", {
            staticClass: "col-3",
            attrs: {
              "form-context": _vm.formContext,
              label: "Rechnungsempfänger E-Mail",
              property: "accountingEmail",
              type: "text",
            },
          }),
          _vm._v(" "),
          _c("csp-desktop-info-card-element", {
            staticClass: "col-3 align-content-end",
            attrs: {
              "form-context": _vm.formContext,
              "hide-label": true,
              label: "Manuelle Nachbearbeitung Rechnung",
              property: "invoiceNeedsManualAdjustment",
              type: "checkbox",
            },
          }),
          _vm._v(" "),
          _c("csp-desktop-info-card-element", {
            staticClass: "col-3",
            attrs: {
              "form-context": _vm.formContext,
              label: "Deckelung Autohaus Haftpflichtgebühr je Monat",
              property: "monthlyFeeCap",
              type: "number",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c("csp-desktop-info-card-element", {
            staticClass: "col-3",
            attrs: {
              "form-context": _vm.formContext,
              label: "Fußtext",
              property: "footerText",
              type: "autogrowtextarea",
            },
          }),
          _vm._v(" "),
          _c("csp-desktop-info-card-element", {
            staticClass: "col-3",
            attrs: {
              "form-context": _vm.formContext,
              label: "Besonderheiten Abrechnung",
              property: "billingModalityRemarks",
              type: "autogrowtextarea",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c("csp-desktop-info-card-element", {
            staticClass: "col-3",
            attrs: {
              "form-context": _vm.formContext,
              "hide-label": true,
              label: "Rechtlich identische Filialen",
              property: "hasLegallyIdenticalFirms",
              type: "checkbox",
            },
          }),
          _vm._v(" "),
          _c("csp-desktop-info-card-element", {
            staticClass: "col-3",
            attrs: {
              "form-context": _vm.formContext,
              "hide-label": true,
              label: "Anlieferungs-Vorgänge aktivieren",
              property: "enableDeliveryClaims",
              type: "checkbox",
            },
          }),
          _vm._v(" "),
          _c("csp-desktop-info-card-element", {
            staticClass: "col-3",
            attrs: {
              "form-context": _vm.formContext,
              "hide-label": true,
              label: "2-Faktor Authentifizierung erforderlich",
              property: "requires2fa",
              type: "checkbox",
            },
          }),
          _vm._v(" "),
          _c("csp-desktop-info-card-element", {
            staticClass: "col-3",
            attrs: {
              "form-context": _vm.formContext,
              "hide-label": true,
              label: "Schadenpositionen mit KI anlegen",
              property: "canCreateCostUnitsWithOcr",
              type: "checkbox",
            },
          }),
          _vm._v(" "),
          _c("csp-desktop-info-card-element", {
            staticClass: "col-3",
            attrs: {
              "form-context": _vm.formContext,
              "hide-label": true,
              label: "Nutzung von Kundenvorlagen",
              property: "canUseCustomerTemplates",
              type: "checkbox",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.showActionButtons
        ? _c(
            "b-row",
            { staticClass: "mt-3" },
            [
              _c("b-col", { attrs: { cols: "6" } }),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "text-right", attrs: { cols: "6" } },
                [
                  _vm.showDeleteButton
                    ? _c(
                        "b-button",
                        { on: { click: _vm.openDeleteConfirmationModal } },
                        [
                          _vm._v(
                            "\n                Firmengruppe löschen\n            "
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: { "cancel-title": "Abbrechen", title: "Firmengruppe löschen" },
          on: { ok: _vm.deleteFirmGroup },
          model: {
            value: _vm.isDeleteConfirmationModalOpen,
            callback: function ($$v) {
              _vm.isDeleteConfirmationModalOpen = $$v
            },
            expression: "isDeleteConfirmationModalOpen",
          },
        },
        [
          _vm._v(
            "\n        Wollen Sie die Firmengruppe wirklich löschen?\n    "
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }